
const ShippingSettingsReducer = (state = {}, action) => {
    switch (action.type) {
        case "getSearchSettingsSuccess": {
            return Object.assign({}, state, {
                SearchSettings: action.data,
            });
            break;
        }
        case "getSearchSettingsFailure": {
            return Object.assign({}, state, {
                SearchSettings: action.data,
            });
            break;
        }
        case "getSettingDetailsSuccess": {
            return Object.assign({}, state, {
                settingsDetails: action.data,
            });
            break;
        }
       case "getSettingsDetailsFailure": {
            return Object.assign({}, state, {
                settingsDetails: action.data,
            });
            break;
        }
        case "SettingsUserDetails": {
            return Object.assign({}, state, {
                ShippingDetails: action.data,
            });
            break;
          }
        
       
        default: {
            return state;
        }
    }
};
export default ShippingSettingsReducer;
